export default function filterLatLng(list) {
  if (Array.isArray(list)) {
    list.forEach((el) => {
      if (!el.latitude || el.latitude < -90 || el.latitude > 90 ||
        !el.longitude || el.longitude < -180 || el.longitude > 180) {
        el.longitude = 0;
        el.latitude = 0;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/general/gestionLatLng.js